import _ from 'lodash'
import type {ComponentWithResolvedDataItems, CoreExportFormat, RawComponentExport} from '@wix/document-services-types'
import {schemaService} from '@wix/format-converter-schemas'
import {corePlugins} from './core'
import type {CorePlugin, CorePluginFunction} from './types'

const packPlugins: CorePlugin[] = corePlugins
const unpackPlugins: CorePlugin[] = _.reverse([...packPlugins])

const runPlugins = <R>(
    plugins: CorePlugin[],
    componentExport: ComponentWithResolvedDataItems,
    getPluginFuncToRun: (plugin: CorePlugin) => CorePluginFunction | undefined
): R => {
    for (const plugin of plugins) {
        const pluginFunc = getPluginFuncToRun(plugin)
        pluginFunc?.(componentExport, schemaService)
    }

    return componentExport as R
}

export const packComponent = (componentExport: RawComponentExport): CoreExportFormat =>
    runPlugins(packPlugins, componentExport, p => p.pack)

export const unpackComponent = (componentExport: CoreExportFormat): RawComponentExport =>
    runPlugins(unpackPlugins, componentExport, p => p.unpack)
